exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#login_navbar{padding:15px;display:flex;justify-content:flex-end}#login_navbar #login-button{margin-right:10px}", ""]);

// exports
